import { useState, type FormEvent } from 'react';
import { Button, Input } from '../atoms';

interface DateRangeFormProps {
  /** ISO start/end of the current custom range, if any. */
  initial?: { from: string; to: string };
  onApply: (range: { from: string; to: string }) => void;
}

/** Pick whole local days; applies [first day 00:00, day after last 00:00). */
export function DateRangeForm({ initial, onApply }: DateRangeFormProps) {
  const [from, setFrom] = useState(initial ? toDateInput(initial.from) : toDateInput(Date.now() - 7 * 86_400_000));
  const [to, setTo] = useState(initial ? toDateInput(Date.parse(initial.to) - 1) : toDateInput(Date.now()));
  const invalid = !from || !to || from > to;

  function submit(event: FormEvent) {
    event.preventDefault();
    if (invalid) return;
    const start = new Date(`${from}T00:00`);
    const end = new Date(`${to}T00:00`);
    end.setDate(end.getDate() + 1);
    onApply({ from: start.toISOString(), to: end.toISOString() });
  }

  return (
    <form className="flex flex-wrap items-center gap-2" onSubmit={submit}>
      <label>
        <span className="sr-only">From</span>
        <Input type="date" value={from} max={to} onChange={(e) => setFrom(e.target.value)} />
      </label>
      <span className="text-fg-muted">to</span>
      <label>
        <span className="sr-only">To</span>
        <Input type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} />
      </label>
      <Button type="submit" variant="primary" disabled={invalid}>
        Apply
      </Button>
    </form>
  );
}

function toDateInput(value: number | string): string {
  const d = new Date(value);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
